import { render, staticRenderFns } from "./FiltersTkGenerationFromOIK.vue?vue&type=template&id=58449ac6&scoped=true&"
import script from "./FiltersTkGenerationFromOIK.vue?vue&type=script&lang=ts&"
export * from "./FiltersTkGenerationFromOIK.vue?vue&type=script&lang=ts&"
import style0 from "./FiltersTkGenerationFromOIK.vue?vue&type=style&index=0&id=58449ac6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58449ac6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
